import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const NewsMentionCardStyles = styled.div`
  border-bottom: 1px solid ${Colors.accent.grey5.standard};
  margin-bottom: 2px;
  padding: 25px 0;
  word-break: break-word;

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${Colors.primary.black.standard};
    text-decoration: none;
  }

  .news-media {
    background-color: ${Colors.secondary.grey6.standard};
    display: none;
  }

  h4 {
    margin-bottom: 5px;
  }
  h6 {
    color: ${Colors.accent.grey2.standard};
    font-family: 'source-sans-pro', sans-serif;
    font-size: 13px;
    margin-bottom: 5px;
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    border: 0;
    width: calc((100% - 50px) / 2);

    a:link,
    a:visited,
    a:hover,
    a:active {
      display: flex;
      flex-direction: row;
      margin: -10px;
      overflow: hidden;
      padding: 10px;

      .news-media {
        display: flex;
        justify-content: center;
        max-height: 200px;
        overflow: hidden;
        width: 50%;
        position: relative;

        .news-media-none {
          align-items: center;
          display: flex;
          height: 100%;
          justify-content: space-around;
          height: 200px;
          max-width: 288px;
          width: 100%;
        }

        img {
          max-height: 200px;
          object-fit: cover;
          min-width: 250px;
        }
      }

      .news-details {
        padding: 25px 0 0 25px;
        width: 50%;
      }
    }

    a:hover {
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.2);
    }
  }
`;
